import type { ServiceKey } from "../api/product-service-info";

export const coreServiceFields = [
  { key: "shippingLeadTime", title: "发货时效", max: 100, content: "现货商品下单后 48 小时内发货；定制商品在确认设计稿后，通常需 5-7 个工作日生产发货。具体交期以双方最终确认为准。" },
  { key: "freeShippingDescription", title: "运费说明", max: 500, content: "包装属于抛货/重货，系统运费仅供参考。大批量订单建议走物流专线，具体运费请联系客服核算改价。" },
  { key: "guaranteeDescription", title: "售后保障", max: 500, content: "定制类商品非质量问题不支持退换货。印刷存在 10% 左右的合理色差及 1-2mm 模切误差，属于行业正常现象。如遇严重质量问题，请在签收后 3 日内联系客服处理。" },
  { key: "craftsmanshipDescription", title: "定制须知", max: 500, content: "定制需提供 AI、CDR 或 PDF 格式矢量文件。生产前客服会与您核对效果图，一经确认定稿安排生产，将无法再修改内容。" },
] as const satisfies ReadonlyArray<{ key: Exclude<ServiceKey, "material">; title: string; max: number; content: string }>;
